import { getIsCoursePublishing } from '@/exceed';

export default ({ videoVersion }) => ({
  toolbar: false,
  disableEditing: getIsCoursePublishing(videoVersion),
});
